import {call, put, select, take, takeEvery, takeLatest,} from "redux-saga/effects";
import {
    APP_API_URL_SAGA,
    APP_APPCODE_CHANGE_SAGA,
    APP_APPCODE_STORAGE_KEY,
    APP_INIT_SAGA,
    APP_INITIALIZED,
    APP_LOCALE_CHANGE_SAGA,
    APP_LOCALE_STORAGE_KEY,
    APP_SET_API_URL_INFO,
    APP_SET_AUTHCODE_INFO,
    APP_SET_MODULE_INFO,
    APP_SET_SYSTEM_INFO,
    APP_SYSTEM_INFO_SAGA,
    APP_UPDATE_PARAMAETER,
    APP_UPDATE_PARAMETER_SAGA,
    CLOSE_SIDEBAR,
    GET_APP_DATA_SAGA,
    GET_APP_DATA_SUCCESS,
    GET_APP_MODULE_SAGA,
    OPEN_SIDEBAR,
    TOGGLE_SIDEBAR
} from "@/Redux/App/AppConstants";
import {fetchQuery, graphql} from "relay-runtime";
import {relayAuthEnvironment, relayGuestEnvironment,} from "@/RelayEnvironment";
import {DRAWER_WIDTH, DRAWER_WIDTH_CLOSED,} from "@/Components/Sidebar/Constants";
import {USER_LOGOUT} from "@/Redux/User/Constants";
import {Environment} from "react-relay";
import {SYSTEM_INIT_SAGA, SYSTEM_INITIALIZED,} from "@/Redux/System/SystemConstants";
import {AppSagasServerInfoQueryResponse} from "@/Redux/App/__generated__/AppSagasServerInfoQuery.graphql";
import _ from "lodash";
import {AUTH_INIT_SAGA, AUTH_INITIALIZED} from "@/Redux/Auth/AuthConstants";
import i18next from "@/Translation/Translation";
import {isTablet} from "react-device-detect";
import {getAppCode, selectParameters} from "@/Redux/App/AppReducer";
import UpdateParameterMutation
    from "@/Domains/ConfigurationManagement/Parameter/Parameter/Mutations/UpdateParameterMutation";
import {RootStateOrAny} from "react-redux";
import {logger} from "@/Logger";
import {AppSagasCRW6ModuleQueryResponse} from "@/Redux/App/__generated__/AppSagasCRW6ModuleQuery.graphql";

function* appInitSaga(action: any) {
    yield put({
        type: APP_APPCODE_CHANGE_SAGA,
        payload: {
            appCode: localStorage.getItem(APP_APPCODE_STORAGE_KEY) || "",
        },
    });

    yield take(APP_SET_AUTHCODE_INFO);

    yield put({
        type: APP_API_URL_SAGA,
    });

    yield take(APP_SET_API_URL_INFO);

    // System
    yield put({
        type: SYSTEM_INIT_SAGA,
    });
    yield take(SYSTEM_INITIALIZED);

    // Auth
    yield put({
        type: AUTH_INIT_SAGA,
    });
    yield take(AUTH_INITIALIZED);

    if (isTablet) {
        yield put({type: CLOSE_SIDEBAR});
    } else {
        yield put({type: OPEN_SIDEBAR});
    }

    yield put({
        type: GET_APP_MODULE_SAGA,
    });

    yield put({
        type: APP_INITIALIZED,
    });
}

function* appApiUrlSaga(action: any) {
    const starttime = new Date().getTime();
    logger.log("APP: fetch api url");
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    };

    const appCode = getAppCode();

    logger.log(appCode);
    if (!_.isString(appCode) || _.isEmpty(appCode)) {
        yield put({type: APP_SET_API_URL_INFO, payload: {apiUrl: ""}});
        return;
    }

    // @ts-ignore
    const apiUrl: string = yield fetch(
        "https://license.crent.de/index.php/api/CRW-NEW/urls?appCode=" +
        appCode,
        requestOptions,
    )
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            return data.apiUrl;
        })
        .catch((error) => {
            logger.error(error);
            return import.meta.env.VITE_API_URL;
        });

    if (!_.isString(apiUrl)) {
        yield put({
            type: APP_APPCODE_CHANGE_SAGA,
            payload: {
                appCode: "",
            },
        });
        //throw new Error("failed to load api url");
    }
    const endtime = new Date().getTime();
    logger.log(
        "APP: finished getting api url in " + (endtime - starttime) + "ms",
        apiUrl,
    );

    yield put({type: APP_SET_API_URL_INFO, payload: {apiUrl: apiUrl}});
}

function* openSidebar(action: any) {
    logger.log("APP: open sidebar");
    const bodyWidth = document.getElementsByTagName("body")[0]?.clientWidth;
    yield put({
        type: TOGGLE_SIDEBAR,
        data: {open: true, contentWidth: bodyWidth - 12 - DRAWER_WIDTH},
    });
}

function* closeSidebar(action: any) {
    logger.log("APP: close sidebar");
    const bodyWidth = document.getElementsByTagName("body")[0]?.clientWidth;
    yield put({
        type: TOGGLE_SIDEBAR,
        data: {
            open: false,
            contentWidth: bodyWidth - 12 - DRAWER_WIDTH_CLOSED,
        },
    });
}

function* getAppDataSaga(action: any) {
    const starttime = new Date().getTime();
    logger.log("APP: get app data");
    try {
        // @ts-ignore
        const data = yield fetchQuery(
            // @ts-ignore
            relayAuthEnvironment() as Environment,
            graphql`
                query AppSagasLoadDataQuery {
                    stationList {
                        stations {
                            stationId
                            city
                            country {
                                countryId
                                name
                                sign
                            }
                            disponame
                            email
                            fax
                            isForeignStation
                            isOneWayStation
                            isRentStation
                            isSharingStation
                            latitude
                            longitude
                            name
                            openingdate
                            opentime {
                                breakEndtime
                                breakStarttime
                                endtime
                                opentimeId
                                starttime
                                station
                                weekDay
                            }
                            phonenumber
                            street
                            zipcode
                            autoGenerateVehicleId
                        }
                    }
                    categoryList {
                        categories {
                            categoryId
                            sort
                            enabledVehicleGroups {
                                vehicleGroupId
                            }
                        }
                    }
                    #dispo
                    equipmentList {
                        equipments {
                            equipmentId
                            description
                            showInDispo
                        }
                    }
                    legendList {
                        legends {
                            code
                            color
                            description
                            legendCrw
                            legendShorttext
                            legendGroup
                        }
                    }
                    regionList {
                        regions {
                            region
                            enabledStations {
                                stationId
                            }
                        }
                    }
                    vehicleGroupList {
                        vehicleGroups {
                            vehicleGroupId
                            category
                            categoryText
                            description
                            descriptionWeb
                            isEnabledForInternetUsage
                            sort
                            textWeb
                        }
                    }
                    paymentMethodList {
                        paymentMethods {
                            allowedInContract
                            allowedInInvoice
                            alwaysAllowed
                            descriptionOrm
                            invoiceNotAllowed
                            invoiceText
                            invoiceTextCredit
                            isEnabledForInternet
                            name
                            paymentMethodId
                            paymentProviderCode
                            prepaymentCheck
                            printAccount
                            standardAccount
                        }
                    }
                    countryList {
                        countries {
                            countryId
                            sign
                            active
                        }
                    }
                    documentTypeList {
                        documentType {
                            description
                        }
                    }
                    pricelistList {
                        pricelists {
                            name
                            dontShowInSelection
                        }
                    }
                    parameterList {
                        parameters {
                            parameterId
                            parameter
                            description
                            value
                        }
                    }
                    colorList {
                        colors {
                            code
                            color
                            colorId
                            description
                            legendCrw
                            legendGroup
                            legendShorttext
                        }
                    }
                    userQueryList {
                        queries {
                            queryId
                            description
                            parameters {
                                name
                                type
                                label
                            }
                            category
                        }
                    }
                    queryList {
                        queries {
                            queryId
                            description
                            category
                        }
                    }
                    rightList {
                        rights {
                            rightId
                            right
                            description
                        }
                    }
                    damageStateList {
                        damageStates {
                            damageStateId
                            state
                        }
                    }
                    taxKeyList {
                        taxKeys {
                            taxKeyId
                            taxKey
                            percentage
                            validFrom
                        }
                    }
                    mandant {
                        mandantId
                        logo
                        abasId
                        jasperHeader
                        jasperFooter
                        ownercode
                        modules {
                            enabled
                            name
                        }
                        openRemarkPopupInContract
                    }
                    rateList {
                        rates {
                            rate
                            rateId
                            description
                            groupId
                            mainRate
                        }
                    }
                }
            `,
            {},
        )
        .toPromise()
        .then((data) => {
            return data;
        })
        .catch((error) => {
            logger.error(error);
            throw error;
        });
        const endtime = new Date().getTime();
        logger.log(
            "APP: finished loading app data in " + (endtime - starttime) + "ms",
            data,
        );

        //@ts-ignore
        const app: any = yield select((state) => state.app);

        // @ts-ignore
        const viewData = {}

        yield put({
            type: GET_APP_DATA_SUCCESS,
            data: {...data, viewData: viewData, translations: []},
        });
    } catch (e) {
        yield put({type: USER_LOGOUT});
        console.error(e);
    }
}

function* systemInfoSaga() {
    const starttime = new Date().getTime();
    logger.log("APP: get system info");
    try {
        const res: AppSagasServerInfoQueryResponse = yield fetchQuery(
            // @ts-ignore
            relayGuestEnvironment(),
            graphql`
                query AppSagasServerInfoQuery {
                    system {
                        serverVersion
                    }
                    mandant {
                        mandantId
                        logo
                        abasId
                        jasperHeader
                        jasperFooter
                        ownercode
                        modules {
                            enabled
                            name
                        }
                        openRemarkPopupInContract
                    }
                }
            `,
            {},
        )
        .toPromise()
        .then((data) => {
            return data;
        })
        .catch((error) => {
            logger.error(error);
            throw error;
        });

        if (!_.isString(res.system?.serverVersion)) {
            throw new Error("could not load system info");

        }
        const newServerVersion = import.meta.env.VITE_VERSION;
        if (newServerVersion != "master") {
            const splittedClientVersion = import.meta.env.VITE_VERSION.split(".");
            const newClientVersion = splittedClientVersion[0] + "." + splittedClientVersion[1] + "." + splittedClientVersion[2]

            const splittedServerVersion = res.system?.serverVersion.split(".");
            const newServerVersion = splittedServerVersion[0] + "." + splittedServerVersion[1] + "." + splittedServerVersion[2]

            if (newClientVersion != newServerVersion) {
                throw new Error("Client Version does not match Server Version");

            }
        }


        const formattedModules: any = {};
        for (const moduleKey in res.mandant?.modules) {
            // @ts-ignore
            const module = res.mandant?.modules[moduleKey];
            formattedModules[module.name] = module.enabled;
        }

        const endtime = new Date().getTime();
        logger.log(
            "APP: finished loading mandant data in " +
            (endtime - starttime) +
            "ms",
            res.mandant,
        );
        yield put({
            type: APP_SET_SYSTEM_INFO,
            payload: {
                serverVersion: newServerVersion,
                modules: formattedModules,
                mandant: res.mandant,
            },
        });
    } catch (e) {
        yield put({
            type: APP_SET_SYSTEM_INFO,
            payload: {
                serverVersion: undefined,
            },
        });
    }
}

export function* appChangeLocaleSaga(action: any) {
    const locale = action.payload.locale;

    yield call(
        [localStorage, localStorage.setItem],
        APP_LOCALE_STORAGE_KEY,
        locale,
    );
    yield call([i18next, i18next.changeLanguage], locale);
}

export function* appChangeAppCodeSaga(action: any) {
    const appCode = action.payload.appCode;

    localStorage.removeItem("apiUrl");
    localStorage.removeItem(APP_APPCODE_STORAGE_KEY);
    localStorage.removeItem("environment");
    localStorage.removeItem("username");
    localStorage.removeItem("CRENT_WEB/SELECTED_STATION");
    localStorage.removeItem("CRENT_WEB/ONLY_GROUP_RES_OF_STATION");
    localStorage.removeItem("CRENT_WEB/STATION_FILTER");
    localStorage.removeItem("CRENT_WEB/VEHICLE_GROUP_FILTER");
    localStorage.removeItem("CRENT_WEB/REGION_FILTER");
    localStorage.removeItem("CRENT_WEB/CATEGORY_FILTER");
    localStorage.removeItem("CRENT_WEB/EQUIPMENT_FILTER");

    yield put({
        type: "RESET_APP",
        payload: {},
    });

    yield put({
        type: APP_SET_AUTHCODE_INFO,
        payload: {
            appCode: appCode,
        },
    });
}

export function* appUpdateParameterSaga(action: any) {
    // @ts-ignore
    const parameters = yield select(
        (state) => selectParameters(state as RootStateOrAny).data,
    );

    const params: any[] = [];

    let paramIndex: string | null = null;
    for (const index in parameters) {
        params.push({
            parameterId: parameters[index].parameterId,
            parameter: parameters[index].parameter,
            description: parameters[index].description,
            value: parameters[index].value,
        });
        // @ts-ignore
        if (parameters[index].parameter === action.payload.parameter) {
            paramIndex = index;
        }
    }

    yield put({
        type: APP_UPDATE_PARAMAETER,
        data: {
            parameters: params,
        },
    });

    try {
        UpdateParameterMutation(
            {
                parameter: action.payload.parameter,
                value: action.payload.value,
            },
            (error, success) => {
                if (error) {
                    throw error;
                } else {
                    // @ts-ignore
                    const param = params[paramIndex];
                    const newParam = {
                        ...param,
                        value: action.payload.value,
                    };
                    // @ts-ignore
                    Object.assign(params[paramIndex], newParam);
                }
                action.payload.callback(null);
            },
        );
    } catch (e) {
        action.payload.callback(e);
    }
}

function* getCRW6Module() {
    logger.log("APP: get CRENTWEB6 module info");
    try {
        const res: AppSagasCRW6ModuleQueryResponse = yield fetchQuery(
            // @ts-ignore
            relayGuestEnvironment(),
            graphql`
                query AppSagasCRW6ModuleQuery {
                    mandant {
                        modules {
                            enabled
                            name
                        }
                    }
                }
            `,
            {},
        )
        .toPromise()
        .then((data) => {
            return data;
        })
        .catch((error) => {
            logger.error(error);
            throw error;
        });

        if (_.isEmpty(res.mandant?.modules)) {
            throw new Error("could not load module info");

        }

        const formattedModules: any = {};
        for (const moduleKey in res.mandant?.modules) {
            // @ts-ignore
            const module = res.mandant?.modules[moduleKey];
            formattedModules[module.name] = module.enabled;
        }

        yield put({
            type: APP_SET_MODULE_INFO,
            payload: {
                modules: formattedModules
            },
        });
    } catch (e) {
        yield put({
            type: APP_SET_MODULE_INFO,
            payload: {
                modules: undefined,
            },
        });
    }
}

export function* appUpdateColorSaga(action: any) {
}

function* appSagas() {
    yield takeLatest(APP_INIT_SAGA, appInitSaga);
    yield takeEvery(APP_API_URL_SAGA, appApiUrlSaga);
    yield takeEvery(APP_SYSTEM_INFO_SAGA, systemInfoSaga);
    yield takeLatest(GET_APP_DATA_SAGA, getAppDataSaga);
    yield takeLatest(OPEN_SIDEBAR, openSidebar);
    yield takeLatest(CLOSE_SIDEBAR, closeSidebar);
    yield takeEvery(APP_LOCALE_CHANGE_SAGA, appChangeLocaleSaga);
    yield takeEvery(APP_APPCODE_CHANGE_SAGA, appChangeAppCodeSaga);
    yield takeEvery(APP_UPDATE_PARAMETER_SAGA, appUpdateParameterSaga);
    yield takeLatest(GET_APP_MODULE_SAGA, getCRW6Module);
}

export default appSagas;
